export default "__VITE_ASSET__2BcUr44$__"